import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";

export const SendAccessButton = ({ r, onSent, label = false }) => {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/resellers/${r.id}/invite`);
      toast.success(`Accès envoyé à ${data.email}`);
      onSent?.(r.id, data.invited_at);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
      onSent?.(r.id, null);
    } finally { setBusy(false); }
  };
  const testid = label ? "reseller-form-send-access" : `send-access-${r.email}`;
  if (label) {
    return (
      <Button variant="outline" className="gap-2 sm:mr-auto" onClick={send} disabled={busy} data-testid={testid}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer l'accès
      </Button>
    );
  }
  return (
    <Button size="icon" variant="ghost" onClick={send} disabled={busy} title={`Envoyer l'accès à ${r.email}`} data-testid={testid}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
    </Button>
  );
};
